<template>
  <v-container>
    <v-row justify="space-between" align="center" class="mb-5">
      <v-col cols="12" md="auto" class="ml-auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="shadow-1">
      <v-card flat>
        <!-- Tabla -->
        <v-container>
          <vuescroll
            :ops="{
              bar: {
                background: '#bacfcec0',
                keepShow: true,
              },
            }"
          >
            <v-data-table
              :headers="surveyHeaders"
              :items="surveyList"
              class="elevation-0"
              :loading="isLoading"
              :options.sync="options"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [15, 30, 50, 100],
              }"
              :search="searchQuery"
            >
              <template v-slot:[`item.date`]="{ item }">
                <span class="d-inline pr-2">
                  {{ normalizeDate(item.created_at) }}
                </span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn
                    :disabled="item.cantTest > 0 ? false : true"
                    text
                    icon
                    :color="hover ? 'accent' : 'blue-grey'"
                    @click.stop="goToReport(item.id)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </v-hover>
              </template>
            </v-data-table>
          </vuescroll>
        </v-container>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
// import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";
import moment from "moment";
export default {
  components: { vuescroll },
  data() {
    return {
      isLoading: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      searchQuery: null,
      surveyHeaders: [
        { text: "Nombre", value: "survey_name", width: "20%" },
        { text: "Fecha", value: "date", width: "15%" },
        { text: "Linea", value: "line", sortable: false, width: "15%" },
        { text: "Origen", value: "origin", width: "15%" },
        { text: "Destino", value: "destiny", width: "15%" },
        { text: "Respuestas", value: "answers", width: "15%" },
        // { text: "Acciones", value: "action", width: "15%" }
      ],
      surveyList: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getSurveys();
      },
      deep: true,
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  created() {
    this.getSurveys();
  },

  methods: {
    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async getSurveys() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const payload = {
        page,
        itemsPerPage,
      };

      const accessToken = localStorage.getItem("token");

      axios
        .get(
          `${process.env.VUE_APP_ROOTAPI}/service_survey?page=${page}&itemPerPage=${itemsPerPage}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          this.surveyList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });

      // ANTERIOR CODIGO DE CONSULTA
      // try {
      //     const { data } = await PbxHttpClient.get("service_survey", {
      //         payload
      //     });
      //     this.surveyList = data.data;
      //     this.totalItems = data.total;
      //     // this.totalPages = data.last_page;
      //     // this.currentPage = data.current_page;
      //     // console.log("res", data);
      // } catch (err) {
      //     console.log(err);
      // }
      // this.isLoading = false;
    },
  },
};
</script>

<style></style>
